import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getDieProfileList = (params) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/', {
    headers: authHeader(),
    params: {
      ...params,
    },
  });
};

const getDieProfileListByFilter = (params) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/get/', {
    headers: authHeader(),
    params: {
      ...params,
    },
  });
};

const getDieProfileByOpenWorkOrder = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/active-dies/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};

const getDieProfileDropdown = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/', {
    headers: authHeader(),
    params: {
      fields: 'id,die_number,customer_reference_number,deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};

const getDieProfileNumber = (value) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/get/', {
    headers: authHeader(),
    params: {
      die_number: value,
    },
  });
};
const getDieArchiveProfileList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/archive-list', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getDieProfileById = (dieProfileId) => {
  return axios.get(API_URL + '/api/' + API_VERSION + `/die/${dieProfileId}`, {
    headers: authHeader()
  });
};

const getDieProfileByGroupId = (page, pagesize, id) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/die/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      die_group: id,
    },
  });
};
const addDieProfile = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die/`,
    formData, // Payload for the request body
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};
const updateDieProfile = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/die/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};
const updateDieFile = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/die/${id}/upload-file/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};
const deleteDieProfile = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die/${id}/archive/`, // Include the die group's ID in the URL
    {},
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveDieProfileRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const deleteImage = (id, formPayload) => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/delete-die-files/${id}/`, // Include `id` in the URL
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
      },
      data: formPayload, // Pass the payload in the request body
    },
  );
};


const deleteDrawingDimensionByPerticularId = (id) => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/section-balloon/${id}/`, // Include `id` in the URL
    {
      headers: {
        ...authHeader()
      }
    },
  );
};

const dieProfileService = {
  getDieProfileList,
  getDieProfileNumber,
  getDieArchiveProfileList,
  getDieProfileById,
  getDieProfileByGroupId,
  addDieProfile,
  updateDieProfile,
  updateDieFile,
  deleteDieProfile,
  unArchiveDieProfileRecord,
  deleteImage,
  getDieProfileDropdown,
  getDieProfileByOpenWorkOrder,
  getDieProfileListByFilter,
  deleteDrawingDimensionByPerticularId
};

export default dieProfileService;
